import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BgColorsOutlinedSvg from "@ant-design/icons-svg/es/asn/BgColorsOutlined";
import AntdIcon from "../components/AntdIcon";
var BgColorsOutlined = function BgColorsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BgColorsOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BgColorsOutlined.displayName = 'BgColorsOutlined';
}
export default /*#__PURE__*/React.forwardRef(BgColorsOutlined);